export type Ics234TacticsRow = {
  id: string;
  name: string;
};

export type Ics234StrategyRow = {
  id: string;
  name: string;
  tactics: Ics234TacticsRow[];
};

export type Ics234ObjectiveRow = {
  id: string;
  name: string;
  strategies: Ics234StrategyRow[];
};

export type Ics234MatrixItemRef =
  | { kind: 'objective'; objectiveId: string }
  | { kind: 'strategy'; objectiveId: string; strategyId: string }
  | {
      kind: 'tactic';
      objectiveId: string;
      strategyId: string;
      tacticId: string;
    };

export type Ics234MatrixItemDraft = {
  kind: Ics234MatrixItemRef['kind'];
  name: string;
};

export type Ics234MatrixItemEditState = {
  ref: Ics234MatrixItemRef;
  draft: Ics234MatrixItemDraft;
};

export function ics234MatrixItemKey(ref: Ics234MatrixItemRef): string {
  if (ref.kind === 'objective') {
    return `obj-${ref.objectiveId}`;
  }
  if (ref.kind === 'strategy') {
    return `str-${ref.objectiveId}-${ref.strategyId}`;
  }
  return `tac-${ref.objectiveId}-${ref.strategyId}-${ref.tacticId}`;
}

export function ics234MatrixItemRefsMatch(
  a: Ics234MatrixItemRef,
  b: Ics234MatrixItemRef
): boolean {
  return ics234MatrixItemKey(a) === ics234MatrixItemKey(b);
}
